module.exports = __webpack_public_path__ + "static/EnChartDesktop-8a8804f3ada3ba0351c76a8a022ea2fc.svg";